import { Trans, Translation } from 'react-i18next';
import React from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { formatNetworth } from '@/utils';
import { ErrorMessage } from '@hookform/error-message';
import styles from './index.module.scss';
import { AntdSelect, Tips } from '@/components';

const { Option } = AntdSelect;

const OPTIONS = [
  {
    label: '10',
    value: 10,
  },
  {
    label: '100',
    value: 100,
  },
  {
    label: '1000',
    value: 1000,
  },
  {
    label: '10000',
    value: 10000,
  },
];

export const QuestParticipation = [
  {
    label: (
      <Translation>
        {t => (
          <>
            {t('EligibilitiesFields_fields.p9jkw2')}
            <Tips title="An additional fee of $100 will be incurred." />
          </>
        )}
      </Translation>
    ),
    name: 'permissions.has_web3_id',
    desc() {
      return <Translation>{t => t('EligibilitiesFields_fields.p9jkw2')}</Translation>;
    },
  },
  {
    label: <Translation>{t => t('EligibilitiesFields_fields.1czgn0i')}</Translation>,
    name: 'permissions.min_net_worth',
    desc(v?: number) {
      return (
        <Trans
          i18nKey="EligibilitiesFields_fields.1czgn0i_desc"
          values={{ amount: formatNetworth(v) }}
        />
      );
    },
    // 不要用 =>，需要用到 this
    render(control: Control<FieldValues, object>, disabled?: boolean) {
      const { _formState } = control;
      return (
        <div className={styles.inputContainer}>
          <Translation>
            {t => (
              <Controller
                name={`${this.name}.1`}
                control={control}
                render={({ field }) => (
                  <div className={styles.selectContainer}>
                    <div className={styles.prefix}>$</div>
                    <AntdSelect
                      className={styles.select}
                      value={field.value}
                      onChange={field.onChange}
                      disabled={disabled}>
                      {OPTIONS.map(({ value, label }) => (
                        <Option key={value} className={styles.option} value={value}>
                          {label}
                        </Option>
                      ))}
                    </AntdSelect>
                    <Tips
                      title={
                        <div className={styles.tipContainer}>
                          <div className={styles.row}>
                            <div className={styles.label}>Net worth≥10</div>
                            <div className={styles.value}>$50</div>
                          </div>
                          <div className={styles.row}>
                            <div className={styles.label}>Net worth≥100</div>
                            <div className={styles.value}>$100</div>
                          </div>
                          <div className={styles.row}>
                            <div className={styles.label}>Net worth≥1000</div>
                            <div className={styles.value}>$150</div>
                          </div>
                          <div className={styles.row}>
                            <div className={styles.label}>Net worth≥10000</div>
                            <div className={styles.value}>$200</div>
                          </div>
                        </div>
                      }
                    />
                  </div>
                )}
              />
            )}
          </Translation>
          <ErrorMessage
            errors={_formState?.errors}
            name={`${this.name}.1`}
            render={({ message }) => {
              return <div className={styles.errorMessage}>{message}</div>;
            }}
          />
        </div>
      );
    },
    labelContainerClassName: styles.marginBottom0,
  },
];
